<template>
  <div data-component-group="filter-forms" class="tracking-networks-filters">
    <FiltersForm
      has-phone-sheet
      :applied-filters="appliedFilters"
      :on-clear-filter="clearFilter"
      :has-filters="hasFilters"
      @filter="onFilter"
      @clear="onClearFilters"
      v-model="selectedCountries"
    >
      <template v-slot:phone-actions>
        <slot name="phone-actions" />
      </template>

      <v-text-field
        clearable
        v-model="search"
        type="search"
        label="Network name"
        prepend-inner-icon="search"
        hide-details
      />
    </FiltersForm>
  </div>
</template>

<script>
  import FiltersForm from './FiltersBase';
  import { isNonEmptyStr, isNonEmptyArr, escapeSearch } from '@/utils';
  import filterUrlSync from '@/mixins/filterUrlSync';
  import filterChips, { platformChips } from '@/mixins/filterChips';

  export default {
    mixins: [filterUrlSync, filterChips],
    components: {
      FiltersForm,
    },
    emits: ['filter', 'clearFilters'],
    data() {
      return {
        urlConfig: [
          { field: 'search', urlKey: 'search', type: 'string' },
          { field: 'selectedCountries', urlKey: 'countries', type: 'string[]' },
        ],
        search: null,
        selectedCountries: [],
      };
    },
    computed: {
      hasFilters() {
        const { search, selectedCountries } = this;
        return isNonEmptyStr(search) || isNonEmptyArr(selectedCountries);
      },
      filterChipFields() {
        const platforms = this.$store.getters['users/countries'] || [];

        return [
          {
            model: 'selectedCountries',
            label: this.$t('platform'),
            toChips: platformChips(platforms),
          },
          { model: 'search', label: 'Network name' },
        ];
      },
    },
    methods: {
      onFilter() {
        const formattedSearch = escapeSearch(this.search);

        this.syncFiltersToUrl();
        this.rememberAppliedFilters();

        this.$emit('filter', {
          search: formattedSearch,
          countries: this.selectedCountries,
        });
      },
      onClearFilters() {
        this.search = null;
        this.selectedCountries = [];

        this.clearFiltersUrl();
        this.forgetAppliedFilters();

        this.$emit('clearFilters');
      },
    },
  };
</script>
